//FUNCTIONS ON RESIZE
$(window).on("resize", function (e) {
    if ($(window).width() < 768) {
        $(".departments-internal__icon_centered").remove();
    }
    else {
        if (!$(".departments-internal__icon_centered").length) {
            departmentsInternalAddCurrentTechnologyText.apply($(".departments-internal__icon-list-item:first"));
        }
    }

    departmentsAddScrollIcon();
});
//FUNCTIONS ON RESIZE END

function departmentsAddScrollIcon() {
    if (document.querySelector(".departments-internal") && $(window).width() >= 768) {
        var $departmentsInternal = $(".departments-internal-box__text");
        var textHeight1 = $departmentsInternal[0].scrollHeight || 0;
        var textHeight2 = $departmentsInternal[1].scrollHeight;
        var windowHeight = $(window).height();

        var heightCoeff1 = textHeight1 / windowHeight;
        var heightCoeff2 = textHeight2 / windowHeight;


        if (heightCoeff1 >= .3) {
            $(".departments-internal-box:first").find('.mouse').slideDown();
            $(".departments-internal-box:first .departments-internal-box__text").css('height', $(window).width() > 992 ? 'calc(27vh - 22px)' : 'calc(19vh - 22px)');
        }
        else {
            $(".departments-internal-box:first").find('.mouse').slideUp();
            $(".departments-internal-box__text:first").css('height', 'auto');
        }

        if (heightCoeff2 >= .4) {
            $(".departments-internal-box:last").find('.mouse').slideDown();
            $(".departments-internal-box__text:last").css('height', '27vh');
        }
        else {
            $(".departments-internal-box:last").find('.mouse').slideUp();
            $(".departments-internal-box__text:last").css('height', 'auto');
        }
    }
}

function departmentsInternalAddCurrentTechnologyText() {
    if ($(window).width() >= 768 && $(".departments-internal").length) {
        var $text = $(this).find(".technology-text_hidden").clone().addClass("departments-internal-box__text technology-text scroll-nice");
        var $textwrapper = $(".departments-internal__bottom .departments-internal-box");
        var $textWrapperMouse = $(".departments-internal__bottom .departments-internal-box .mouse");
        var url = $(this).find(".departments-internal__icon-text").html();
        var $btnHire = $(this).find(".hiredeveloper-btn-wrp").clone();
        //ADD ACTIVE CLASS
        $(".departments-internal__icon-list-item").removeClass('active');
        $(this).addClass('active');

        //CHANGE TEXT IN BOTTOM BOX
        $textwrapper.find(".technology-text").remove();
        $text.insertBefore($textWrapperMouse);

        //ADD SCROLL ICON IF NEEDED
        departmentsAddScrollIcon();

        //ADD BIG CENTERED ICON
        $(".departments-internal__icon_centered").remove();

        if ($(this).closest(".departments-internal__top").length) {
            $(this).find(".departments-internal__icon").clone().addClass("departments-internal__icon_centered departments-internal__icon_centered-top").appendTo($(".departments-internal__bottom .departments-internal-box"))
        } else {
            $(this).find(".departments-internal__icon").clone().addClass("departments-internal__icon_centered departments-internal__icon_centered-bottom").appendTo($(".departments-internal__bottom .departments-internal-box"))
        }

        //ADD BUTTON HIRE
        $textwrapper.find(".hiredeveloper-btn-wrp").remove();
        $btnHire.appendTo($textwrapper);
    }
}

$(".departments-internal__icon-list-item").on("click touchstart", departmentsInternalAddCurrentTechnologyText);
departmentsInternalAddCurrentTechnologyText.call($(".departments-internal__icon-list-item")[0]);
departmentsAddScrollIcon();

//------------------------------------------------------------//


//------------------------------------------------------------//

//DEPARTMENTS INTERNAL SLIDER
function departmentsInternalSlider() {
    var slidesCount = $(".departments-int-mob__icon-list-item ").length;
    var $sliderContainer = $(".departments-slider");
    var $sliderContainerImage = $(".departments-image-slider");
    var arrowLeftSrc = $(".departments-int-mob__icon-list-item").eq(slidesCount - 1).find('i').clone();
    if (!arrowLeftSrc.length) {
        arrowLeftSrc = $(".departments-int-mob__icon-list-item").eq(slidesCount - 1).find('img').clone();
        arrowLeftSrc = $('<img>',{src: arrowLeftSrc.attr('src')})
    }
    var arrowRightSrc = $(".departments-int-mob__icon-list-item").eq(1).find('i').clone();
    if (!arrowRightSrc.length) {
        arrowRightSrc = $(".departments-int-mob__icon-list-item").eq(1).find('img').clone();
        arrowRightSrc = $('<img>',{src: arrowRightSrc.attr('src')})
    }

    for (var i = 0; i < slidesCount; i++) {
        var image = $(".departments-int-mob__icon").clone().eq(i).addClass("departments-slider__icon" + ($('.departments-int-mob__icon + .wide').length ? ' wide' : ''));
        var title = $(".departments-int-mob__icon-text").clone().eq(i).removeClass().addClass("departments-int-mob-box__title slider__title uppercase");
        var text = $(".departments-int-mob__icon-list .technology-text_hidden").clone().eq(i).addClass("departments-internal-box__text technology-text departments-int-mob-box__text_p");
        var technologyName = $(".departments-int-mob__icon-list-item").eq(i).data("technology");

        $sliderContainer.append('<div class = "departments-slider__item_wrapper"><div class="departments-slider__item departments-int-mob-box departments-int-mob__box"></div>');
        $(".departments-slider__item").eq(i).append([title, text]);

        $sliderContainerImage.append('<div class = "departments-image-slider__item_wrapper"/>');
        $(".departments-image-slider__item_wrapper").eq(i).append(image);
    }

    if ($().slick) {
        $sliderContainer.slick({
            infinite: true,
            dots: true,
            arrows: false,
            appendDots: $('.departments-int-mob__dots-container'),
            adaptiveHeight: true,
            asNavFor: '.slider-nav',
            customPaging : function(slider, i) {
                var $images = $('.departments-int-mob__icon-list svg, .departments-int-mob__icon-list i') || '';
                return "<span>" + ($images.eq(i).length ? $images.eq(i)[0].outerHTML : '') + "</span>";
            },
        });

        $sliderContainerImage.slick({
            arrows: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 100,
            nextArrow: '<span class="departments-slider__arrow departments-slider__arrow-right"></span>',
            prevArrow: '<span class="departments-slider__arrow departments-slider__arrow-left"></span>',
            infinite: true,
            asNavFor: '.slider-nav'
        });
    }

    $(".departments-slider__arrow-left").append(arrowLeftSrc);
    $(".departments-slider__arrow-right").append(arrowRightSrc);

    $sliderContainerImage.on('beforeChange', function () {
        $(".departments-slider__arrow").addClass("active")
    });

    $sliderContainerImage.on('swipe', function () {
        $(".departments-slider__arrow").addClass("active")
    });

    $sliderContainerImage.on('afterChange', function (event, slick, currentSlide) {
        var prevSrcNumber = (currentSlide - 1) % slidesCount;
        var NextSrcNumber = (currentSlide + 1) % slidesCount;

        arrowLeftSrc = $(".departments-int-mob__icon-list-item").eq(prevSrcNumber).find('i').clone();
        if (!arrowLeftSrc.length) {
            arrowLeftSrc = $(".departments-int-mob__icon-list-item").eq(prevSrcNumber).find('img').clone();
            arrowLeftSrc = $('<img>',{src: arrowLeftSrc.attr('src')})
        }

        arrowRightSrc = $(".departments-int-mob__icon-list-item").eq(NextSrcNumber).find('i').clone();
        if (!arrowRightSrc.length) {
            arrowRightSrc = $(".departments-int-mob__icon-list-item").eq(NextSrcNumber).find('img').clone();
            arrowRightSrc = $('<img>',{src: arrowRightSrc.attr('src')})
        }

        $(".departments-slider__arrow-left").children().remove();
        $(".departments-slider__arrow-right").children().remove();
        $(".departments-slider__arrow-left").append(arrowLeftSrc);
        $(".departments-slider__arrow-right").append(arrowRightSrc);
        $(".departments-slider__arrow").removeClass("active")
    });


}

departmentsInternalSlider();

//DEPARTMENTS INTERNAL SLIDER END

//------------------------------------------------------------//

//DEPARTMENTS INTERNAL DOTS

function departmentsInternalDots() {

    var $dots = $(".departments-int-mob").find(".slick-dots");

    $dots.find("li").each(function (index) {

        var $imageSrc = $(".departments-int-mob__icon:eq(" + index + ")").attr("src");
        if ($imageSrc) {
            var listItemClass = $imageSrc.split("/");
            listItemClass = listItemClass[listItemClass.length - 1].split(".")[0];
            $(this).addClass("departments-dots-item_" + listItemClass);
        }

        var $text = $(".departments-int-mob__icon-text:eq(" + index + ")").clone();
        $(this).append($text);
    })
}

departmentsInternalDots();
//DEPARTMENTS INTERNAL DOTS END

//------------------------------------------------------------//

// DEPARTMENTS INTERNAL END

//ANCHOR SMOOTH SCROLLING DEPARTMENTS
$(".departments-int-mob__dots-container").on("click","li", function (event) {
    setTimeout(function() {
        event.preventDefault();
        var id  = $("#departments-anchor"),
            top = $(id).offset().top;
        $('body,html').animate({scrollTop: top}, 500);
    }, 200);
});
//END ANCHOR SMOOTH SCROLLING DEPARTMENTS

//CHOOSE NEEDED TECHNOLOGY BY LINK HASH IN QA-PM DEPARTMENTS INTERNAL
if (document.location.hash === '#qa') {
    $(".icon-qa-manual").click();
}
else if (document.location.hash === '#pm') {
    $(".icon-managers").click();
}
//CHOOSE NEEDED TECHNOLOGY BY LINK HASH IN QA-PM DEPARTMENTS INTERNAL END

//READMORE ON PARAGRAPHS WRAPPER
function readmore(destroy, e) {
    var $paragraphsWrapper = $(".readmore");
    var numberOfShownParagraphs = +$paragraphsWrapper.attr("data-readmore");

    if (destroy !== 'destroy') {
        //SET THE READMORE BUTTON
        var button = document.createElement('div');
        var textClosed = $("[data-readmore]").data('collapsedName');
        var textOpened = $("[data-readmore]").data('expandedName');
        button.classList.add("btn_readmore", "js-open");
        button.innerHTML = textClosed;

        //HIDE PARAGRAPHS WITH SERIAL NUMBER MORE THEN numberOfShownParagraphs
        $paragraphsWrapper.find("p:gt(" + (numberOfShownParagraphs - 1) + ")").hide();

        if (!document.querySelector('.btn_readmore')) {

            $paragraphsWrapper.find('p:visible:last').after(button);

            $(".btn_readmore").on("click", function () {
                if ($(this).hasClass("js-open")) {
                    $(this)
                        .removeClass("js-open")
                        .addClass("js-close")
                        .insertAfter($paragraphsWrapper.find('p:last'))
                        .html(textOpened);
                    $paragraphsWrapper.find('p').show();
                } else {
                    $paragraphsWrapper.find("p:gt(" + (numberOfShownParagraphs - 1) + ")").slideUp();
                    $(this)
                        .removeClass("js-close")
                        .addClass("js-open")
                        .insertAfter($paragraphsWrapper.find('p:visible:last'))
                        .html(textClosed);
                }
            });
        }
    }

    else {
        $paragraphsWrapper.find('p').show();
        if (document.querySelector('.btn_readmore')) {
            $(".btn_readmore").remove();
        }
    }
}


//READMORE ON PARAGRAPHS WRAPPER END

//------------------------------------------------------------//

//STARTUP READMORE
function readMoreOnStartup(e) {

    if ($(window).width() < 768) {
        readmore(e);
    }
    else {
        readmore('destroy')
    }
}

readMoreOnStartup();
//STARTUP READMORE END
